import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared-service/shared.service';
import { environment } from '../../../environments/environment';
import { UnderMainatanceLabelConstant } from '../../constants/label-constants';

@Component({
  selector: 'app-under-mainatance',
  templateUrl: './under-mainatance.component.html',
  styleUrls: ['./under-mainatance.component.scss'],
})
export class UnderMainatanceComponent {
  labelConstant: any;

  constructor(
    private readonly sharedService: SharedService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.labelConstant = UnderMainatanceLabelConstant;
    this.sharedService.setData('Under Maintenance');
    if (!environment.isUnderMaintance) {
      this.router.navigate(['']);
    }
  }
}
